import { decodeApiBaseParam } from './apiBaseCodec';

/** WebView 嵌入页需全程保留的 URL 参数 */
export const EMBED_QUERY_KEYS = [
  'deviceId',
  'apiBase',
  'lang',
  'walletKey',
  'walletName',
  'packageName'
];

export function persistEmbedParamsFromSearch(search) {
  try {
    const params = new URLSearchParams(search || window.location.search);
    EMBED_QUERY_KEYS.forEach(key => {
      const value = params.get(key);
      if (value) {
        const stored =
          key === 'apiBase' ? decodeApiBaseParam(value) : value;
        sessionStorage.setItem(`embed_${key}`, stored);
      }
    });
  } catch (_) {
    /* ignore */
  }
}

export function getStoredEmbedParam(key) {
  try {
    const raw = sessionStorage.getItem(`embed_${key}`) || '';
    if (key === 'apiBase' && raw) {
      return decodeApiBaseParam(raw);
    }
    return raw;
  } catch (_) {
    return '';
  }
}

export function mergeEmbedQuery(query = {}) {
  const merged = { ...(query || {}) };
  const fromUrl = new URLSearchParams(window.location.search);

  EMBED_QUERY_KEYS.forEach(key => {
    if (merged[key]) return;
    const fromLocation = fromUrl.get(key);
    if (fromLocation) {
      merged[key] = fromLocation;
      return;
    }
    const stored = getStoredEmbedParam(key);
    if (stored) {
      merged[key] = stored;
    }
  });

  return merged;
}

/** 路由跳转时带上 deviceId / apiBase 等参数 */
export function pushWithEmbedQuery(router, path) {
  const query = mergeEmbedQuery(router.currentRoute.value.query);
  return router.push({ path, query });
}
